import { Component, OnInit } from '@angular/core';
import { Tab } from 'src/app/models/tab';
import { DataService } from 'src/app/services/data.service';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css']
})
export class HomeComponent implements OnInit {
  tabs: Tab[] = [];
  dates: string[] = [];

  constructor(private ds: DataService) { }

  ngOnInit() {

    this.ds.GetUser().subscribe(obs => {
      this.ds.GetTabs()
      .subscribe(n => {
        if (n.length === 0) {
          // this.ds.AddTab();

          // this.ds.GetTabs()
          // .subscribe(x => {
          //   this.tabs = x;

          // });
        } else {
          this.tabs = n;
        }
      });
    });
  }

  onSearchBtnClick(event) {
    const dateList = event.dates.map(n => {
      const d = (new Date(n)).toLocaleDateString().split('/');
      return d[2] + '-' + d[0].padStart(2, '0') + '-' + d[1].padStart(2, '0');
    });

    this.ds.tabs[event.tab].dateRange.push(dateList);

    this.ds.GetRecords(dateList, event.tab);

  }

  updateRecs(event: any) {

    this.ds.UpdateRecords(event.data, event.index)
    .subscribe(obs => {
    });
  }
}
